// extracted by mini-css-extract-plugin
export default {"iframeContainer":"gSYn5","iframe":"LCFXl"};